import MuiFormControlLabel from "@mui/material/FormControlLabel";
const FormControlLabel = MuiFormControlLabel;
export default FormControlLabel;
